import { Metamodel } from 'app/model/base/model';

import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { SqlServerLinkedService } from 'shell-models-lib';

/**
 * Amazon RDS is available on several database instance types and provides you with six familiar database engines to
 * choose from, including Amazon Aurora, PostgreSQL, MySQL, MariaDB, Oracle Database, and SQL Server.
 *
 * This is Amazon RDS for SQL Server, so it is exactly the same as SQL Server. But is it a good idea to inherit it
 * directly? Or both AmazonRdsSqlServerLinkedService and SqlServerLinkedService inherit a same class.
 *
 * amazonRdsSqlServerLinkedService instanceof SqlServerLinkedService === true
 */
@Metamodel.model({
    name: adfModelTypeMap.amazonRdsSqlServer.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AmazonRdsSqlServer_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AmazonRdsSqlServer_DisplayText)
    ]
})
export class AmazonRdsSqlServerLinkedService extends SqlServerLinkedService {
}
